import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementSalesReceipts } from "@/components/features/management/sales/receipts";

import { useConfirmParams } from "./hooks";

export const ManagementSalesReceiptsPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="領収書" url={generatePath(PATHS.HOTEL.MANAGEMENT.SALES.RECEIPTS, { hotelID })}>
			<ManagementSalesReceipts hotelID={hotelID} />
		</PageMeta>
	);
};

ManagementSalesReceiptsPage.displayName = "ManagementSalesReceiptsPage";
